/**
 * Component to display the violation message of a window that violates division guideline
 * Two violation types: hard and soft. User will have to correct the hard violations in order 
 * to resubmit the window request edit/creation.
 * @description props.violation must exist, and be an violation instance returned from guideline 
 * validator service. Below is one example
 *      {
 *           "ruleId": 3,
 *           "message": "Between West Stockton to Fresno Startime should be >= 2230 if window is planned From Monday-Saturday",
 *           "warningType": "Soft"
 *      }
 */
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ViolationCard from '../ViolationCard';

import './ViolationModal.css';

const ViolationModal = (props) => {
    const [ show, setShow ] = useState(false);

    useEffect(() => {
        setShow(props.violations && props.violations.length > 0);
    }, [props.violations]);

    const onClose = () => {
        setShow(false);
        props.onClose && props.onClose();
    }

    const onProceed = () => {
        setShow(false);
        props.onProceed && props.onProceed();
    }

    const violationItems = props.violations.map((aViolation, idx) => 
        <ViolationCard key = { idx } violation = { aViolation } />
    );

    const hardViolations = props.violations.filter(aViolation => aViolation.warningType === 'Hard');

    return (
        <Modal className='clsViolationModal' show={show}>
            <Modal.Header>
                <Modal.Title>Guideline Violations</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { violationItems }
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-bwwp-secondary" onClick = { onClose }>Close</Button>
                <Button className="btn btn-bwwp-primary" disabled={hardViolations.length > 0} onClick = { onProceed }>Proceed</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViolationModal;